
import { cmsasset } from '@kit/utils/Formats'


export const navbar = {

  //optional. if it will shrink on scroll
  scrollShrink: true, //false,

  subitemsRevealDuration: 0,

  //the mergeable classes for the outer fixed wrapper
  outerContainerClassesDesktop: "hta-nav-outer",
  outerContainerClassesMobile: "hta-nav-outer",

  backgroundColor: "var(--dark-blue)",
  shrinkColor:"var(--dark-blue)",

  logoWrapperClasses:"hta-logo-wrapper",

  hamburgerButtonClasses:"hta-hamburger-button",

  //the logo and aria text
  logoSrc:cmsasset("/cms-static-assets/North-State-ExpressLogoRastor-PNGNorth-State-Logo-Color.png"),
  logoAriaAlt:"North State Express Navigation Logo",

  desktopLayout:"banner",

  banner: {
    hasRightArea:false,
    hasLeftLogoArea:true,
    navAreaClasses:"sb-align-2right",
    topAreaClasses:"sb-content-space-between sb-align-2bottom sb-alt2"
  },

  //required
  height: "130px",
  shrinkHeight: "70px",


  padding: "14px",
  shrinkPadding: "5px",

  //optional. The top gap
  topGap: "0px"
    
}

export const sideDrawer = {
  topNavHeight:"50px",
  outerClasses:"hta-side-nav-drawer"
}